class GoogleAnalytics {
	constructor() {}

	goal(goal) {
		console.log(`gt goal: ${goal}`);

		(dataLayer = window.dataLayer || []).push({
			'eCategory': goal,
			'eAction': 'sentForm',
			'event': 'GTMForms'
		});
	}
}

export default GoogleAnalytics;
